import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { determineStateData, isStateRequiredCountry } from 'commons/utils'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const State = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()
  const country = useWatch({ control, name: `subjectsInfo.${index1 as 0}.addressesInfo.${index2 as 0}.country` })
  const state = useWatch({ control, name: `subjectsInfo.${index1 as 0}.addressesInfo.${index2 as 0}.state` })
  const states = determineStateData(country)

  // disable input if it has one option and it's selected
  const isDisabled = states.length === 1 && state === states[0].value

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.addressesInfo.${index2 as 0}.state`}
      control={control}
      rules={{
        validate: (value) =>
          !!value || isAllInfoUnavailable || !isStateRequiredCountry(country) ? undefined : '"13. State" required'
      }}
      render={({ field }) => (
        <FF2
          required={isStateRequiredCountry(country) && !isAllInfoUnavailable}
          field={field}
          label="13. State"
          input={(props) => (
            <Select
              {...props}
              searchable
              disabled={isAllInfoUnavailable || isDisabled}
              data={states}
              emptyOption={{ label: 'Not selected', value: '' }}
              data-qa="13. State"
              options-data-qa="13. State option"
            />
          )}
        />
      )}
    />
  )
}
